
export default (number, precentage) => {
  const discount = number * (precentage/100)
  return (number - discount).toFixed(2)
}